/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Mobile sort-sheet fix (Claude).
 * The collection "Sort by" sheet is position:fixed on mobile. The collection section wrapper
 * .shopify-section.scroll-reveal.is-revealed keeps a leftover transform + will-change:transform after its
 * scroll-reveal animation; a transformed ancestor becomes the containing block for the fixed child, pushing
 * the sort sheet far off-screen. This injects a <=640px override that neutralises the leftover transform.
 */
(function () {
  var css = '@media screen and (max-width: 640px) {' +
    '.shopify-section.scroll-reveal.is-revealed { transform: none !important; will-change: auto !important; }' +
    '}';
  function inject() {
    if (document.getElementById('vero-sort-sheet-fix')) return;
    var style = document.createElement('style');
    style.id = 'vero-sort-sheet-fix';
    style.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(style);
  }
  if (document.head) { inject(); }
  else if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', inject); }
  else { inject(); }
})();

/**
 * Optional "Vehicle VIN" field on the cart + mini-cart (Claude).
 *
 * Adds a single optional text input so customers can supply their VIN for fitment
 * verification. The value is stored as a Shopify CART ATTRIBUTE named "Vehicle VIN"
 * (input name="attributes[Vehicle VIN]"), so it carries through checkout and shows on
 * the order's "Additional details" for the team to verify fitment. It is never required.
 *
 * Why JS (and not a hand-edit of the 44KB main-cart.liquid): the field is injected into
 * the theme's real cart forms, so it posts as a normal cart attribute on checkout, and is
 * ALSO saved live via /cart/update.js on change so it survives navigation. This keeps the
 * change surgical and isolated inside the theme's sanctioned customisation hook.
 *
 * Surfaces:
 *   - Cart page  -> form.cart-recap (inserted just above the tax/shipping notice, by the checkout button).
 *   - Mini-cart  -> #mini-cart .mini-cart__recap (inserted above the checkout buttons).
 * Does NOT touch the existing order "note" field or any line-item properties.
 */
(function () {
  var ATTR_KEY = 'Vehicle VIN';
  var currentVin = '';

  var CSS = '' +
    '.vero-vin{margin:16px 0 4px;}' +
    '.vero-vin__label{display:block;margin-bottom:6px;font-size:.95em;line-height:1.3;}' +
    '.vero-vin__input{width:100%;box-sizing:border-box;}' +
    '.vero-vin__help{margin:6px 0 0;font-size:.82em;line-height:1.4;opacity:.7;}' +
    '#mini-cart .vero-vin{margin:12px 0 4px;}' +
    '#mini-cart .vero-vin__label{font-size:.9em;}' +
    '#mini-cart .vero-vin__help{font-size:.78em;}';

  function injectStyle() {
    if (document.getElementById('vero-vin-style')) return;
    var style = document.createElement('style');
    style.id = 'vero-vin-style';
    style.appendChild(document.createTextNode(CSS));
    (document.head || document.documentElement).appendChild(style);
  }

  function buildField(scope) {
    var wrap = document.createElement('div');
    wrap.className = 'vero-vin';
    wrap.setAttribute('data-vero-vin', scope);

    var id = 'vero-vin-input--' + scope;

    var label = document.createElement('label');
    label.className = 'vero-vin__label text--strong';
    label.setAttribute('for', id);
    label.textContent = 'Vehicle VIN number (optional)';

    var input = document.createElement('input');
    input.type = 'text';
    input.id = id;
    input.name = 'attributes[' + ATTR_KEY + ']';
    input.className = 'vero-vin__input form__field form__field--text';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('spellcheck', 'false');
    input.setAttribute('maxlength', '40');
    input.setAttribute('placeholder', 'e.g. WBA8E9C50GK123456');
    input.setAttribute('data-vero-vin-input', '');
    input.value = currentVin;

    var help = document.createElement('p');
    help.className = 'vero-vin__help';
    help.textContent = "Add it and we'll verify fitment for you — totally optional.";

    wrap.appendChild(label);
    wrap.appendChild(input);
    wrap.appendChild(help);
    return wrap;
  }

  function injectCartPage() {
    var form = document.querySelector('form.cart-recap');
    if (!form || form.querySelector('[data-vero-vin]')) return;
    var anchor = form.querySelector('.cart-recap__notices') || form.querySelector('.cart-recap__checkout');
    if (!anchor || !anchor.parentNode) return;
    anchor.parentNode.insertBefore(buildField('cart'), anchor);
  }

  function injectMiniCart() {
    var recap = document.querySelector('#mini-cart .mini-cart__recap');
    if (!recap || recap.querySelector('[data-vero-vin]')) return;
    var anchor = recap.querySelector('.mini-cart__button-container');
    if (anchor) {
      recap.insertBefore(buildField('mini'), anchor);
    } else {
      recap.appendChild(buildField('mini'));
    }
  }

  function injectAll() {
    injectStyle();
    injectCartPage();
    injectMiniCart();
  }

  function syncAll(value) {
    currentVin = value;
    var inputs = document.querySelectorAll('[data-vero-vin-input]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value !== value) inputs[i].value = value;
    }
  }

  function loadCurrent() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var v = (cart && cart.attributes && cart.attributes[ATTR_KEY]) ? String(cart.attributes[ATTR_KEY]) : '';
        if (v) syncAll(v);
      })
      .catch(function () {});
  }

  document.addEventListener('change', function (event) {
    var el = event.target;
    if (!el || !el.matches || !el.matches('[data-vero-vin-input]')) return;
    var value = (el.value || '').trim();
    syncAll(value);
    var body = { attributes: {} };
    body.attributes[ATTR_KEY] = value;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () {});
  });

  function init() {
    injectAll();
    loadCurrent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  ['cart:refresh', 'product:added', 'cart:updated'].forEach(function (evt) {
    document.documentElement.addEventListener(evt, function () {
      setTimeout(injectAll, 60);
    });
  });

  function observeMiniCart() {
    var mc = document.getElementById('mini-cart');
    if (!mc) return false;
    new MutationObserver(function () { injectAll(); }).observe(mc, { childList: true, subtree: true });
    return true;
  }
  if (!observeMiniCart()) {
    var bodyObs = new MutationObserver(function () {
      if (observeMiniCart()) { bodyObs.disconnect(); injectAll(); }
    });
    bodyObs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/**
 * Store credit badge - cart + mini-cart (Claude, unified).
 * Renders our own pill badge (identical to the product page) in the cart summary Total box and in the
 * mini-cart drawer, computed from the live cart total: max($5, 5% of total) rounded to whole dollars,
 * amount in orange #ff6e00. Hides the Redeemly app's own cart widget (.mcb-cart-widget) so there is
 * exactly one consistent badge. Re-applies on cart updates / drawer re-render.
 */
(function () {
  var cents = null;
  var CSS = '' +
    '.mcb-cart-widget{display:none !important;}' +
    '.vero-credit--cart{display:flex;align-items:center;gap:7px;margin:14px 0 2px;padding:5px 12px;border:1px solid;border-color:rgba(128,128,128,.4);border-radius:999px;background:rgba(128,128,128,.1);font-family:inherit;font-size:.82rem;line-height:1.3;color:inherit;width:-moz-fit-content;width:fit-content;}' +
    '.vero-credit--cart .vero-credit__text{font-weight:500;}' +
    '.vero-credit--cart .vero-credit__amt{font-weight:700;color:#ff6e00;}' +
    '.vero-credit--cart .vero-credit__info{position:relative;display:inline-flex;align-items:center;justify-content:center;width:16px;height:16px;border:1.5px solid currentColor;border-radius:50%;background:transparent;color:inherit;cursor:pointer;flex:0 0 auto;opacity:.85;}' +
    '.vero-credit--cart .vero-credit__i{font-family:Georgia,serif;font-style:italic;font-weight:700;font-size:11px;line-height:1;}' +
    '.vero-credit--cart .vero-credit__tip{position:absolute;bottom:150%;left:0;width:240px;max-width:75vw;background:#111;color:#fff;font-weight:400;font-size:12px;line-height:1.45;padding:11px 13px;border-radius:10px;opacity:0;visibility:hidden;transition:opacity .15s;z-index:40;text-align:left;box-shadow:0 6px 20px rgba(0,0,0,.25);}' +
    '.vero-credit--cart .vero-credit__tip strong{font-weight:700;color:#ff6e00;}' +
    '.vero-credit--cart .vero-credit__info:hover .vero-credit__tip,.vero-credit--cart .vero-credit__info:focus .vero-credit__tip{opacity:1;visibility:visible;}';
  function injectStyle() { if (document.getElementById('vero-credit-cart-style')) return; var s = document.createElement('style'); s.id = 'vero-credit-cart-style'; s.appendChild(document.createTextNode(CSS)); (document.head || document.documentElement).appendChild(s); }
  function dollars(c) { if (c == null) return null; var f = Math.round(c * 0.05); return Math.round(Math.max(500, f) / 100); }
  function pill(d) {
    var w = document.createElement('div');
    w.className = 'vero-credit vero-credit--cart';
    w.innerHTML = '<span class="vero-credit__text">Earn <strong class="vero-credit__amt">$' + d + '</strong> store credit</span>' +
      '<span class="vero-credit__info" tabindex="0" role="button" aria-label="About store credit"><span class="vero-credit__i" aria-hidden="true">i</span>' +
      '<span class="vero-credit__tip" role="tooltip">Earn <strong>$' + d + '</strong> in store credit towards your next purchase.</span></span>';
    return w;
  }
  function sync(ex, d) { var a = ex.querySelector('.vero-credit__amt'); if (a && a.textContent !== '$' + d) a.textContent = '$' + d; var t = ex.querySelector('.vero-credit__tip strong'); if (t && t.textContent !== '$' + d) t.textContent = '$' + d; }
  function placeCart(d) {
    var lines = document.querySelectorAll('form.cart-recap .cart-recap__price-line');
    if (!lines.length) return;
    var ex = document.querySelector('.vero-credit--cart.vero-cc-cartpage');
    if (ex) { sync(ex, d); return; }
    var p = pill(d); p.classList.add('vero-cc-cartpage');
    lines[lines.length - 1].insertAdjacentElement('afterend', p);
  }
  function placeMini(d) {
    var recap = document.querySelector('#mini-cart .mini-cart__recap');
    if (!recap) return;
    var lines = recap.querySelectorAll('.mini-cart__recap-price-line');
    if (!lines.length) return;
    var ex = recap.querySelector('.vero-credit--cart.vero-cc-mini2');
    if (ex) { sync(ex, d); return; }
    var p = pill(d); p.classList.add('vero-cc-mini2');
    lines[lines.length - 1].insertAdjacentElement('afterend', p);
  }
  function render() { injectStyle(); var d = dollars(cents); if (d == null) return; if (location.pathname.indexOf('/cart') === 0) placeCart(d); placeMini(d); }
  function refresh() { fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cents = c.total_price; render(); }).catch(function () {}); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', refresh); } else { refresh(); }
  ['cart:refresh', 'cart:updated', 'product:added'].forEach(function (e) { document.documentElement.addEventListener(e, function () { setTimeout(refresh, 120); }); });
  document.addEventListener('click', function (e) { var t = e.target && e.target.closest && e.target.closest('a[href*="/cart"], [data-action*="cart"], [aria-controls*="mini-cart"], .header__cart, .header__cart-toggle, .js-cart-trigger'); if (t) { setTimeout(render, 300); setTimeout(render, 900); } });
})();
/**
 * Add-ons: Extended Warranty (per item) + Shipping Protection (per order) - Claude. v4 (stable matching)
 * Add-on products are $5 units; quantity multiplies to the charge (snapped to $5).
 *   Warranty = max($25, 10% of the item's line total). Per-item tick.
 *   Shipping = 5% of order value (non-add-on lines). One tick for the order.
 * Eligible items: per-unit price >= $100, vendor != NoMerci, not a gift card, not an add-on.
 * The add-on LINE ROWS are hidden (detected by their product link, NOT by positional index, so cart
 * re-ordering never mis-hides a real product). Rows are matched to cart items by the variant id in the
 * row's title link. Toggling updates total + header count in place, instantly (optimistic), no reload.
 */
(function () {
  var WARRANTY_ID = 67602150195293;
  var SHIP_ID = 67602149507165;
  var WARRANTY_HANDLE = '/products/extended-warranty-2-years';
  var SHIP_HANDLE = '/products/shipping-protection';
  var UNIT = 5, MIN_PRICE_CENTS = 10000, WARRANTY_MIN = 25, EXCL_VENDOR = 'NoMerci Racing Apparel';

  function round5(d) { return Math.round(d / 5) * 5; }
  function warrantyDollars(lineTotalCents) { return Math.max(WARRANTY_MIN, round5(0.10 * lineTotalCents / 100)); }
  function shipDollars(orderCents) { return Math.max(UNIT, round5(0.05 * orderCents / 100)); }
  function isAddon(it) { return it.variant_id === WARRANTY_ID || it.variant_id === SHIP_ID || it.product_type === 'Add-on'; }
  function eligible(it) { return !isAddon(it) && !it.gift_card && it.vendor !== EXCL_VENDOR && it.final_price >= MIN_PRICE_CENTS; }

  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function postJSON(url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); }); }
  function changeLine(key, qty, props) { var b = { id: key, quantity: qty }; if (props) b.properties = props; return postJSON('/cart/change.js', b); }
  function addLine(id, qty, props) { return postJSON('/cart/add.js', { items: [{ id: id, quantity: qty, properties: props }] }); }

  function warrantyLineFor(cart, parentKey) { return cart.items.filter(function (it) { return it.variant_id === WARRANTY_ID && it.properties && it.properties._covers === parentKey; })[0]; }
  function shipLineOf(cart) { return cart.items.filter(function (it) { return it.variant_id === SHIP_ID; })[0]; }
  function orderCentsOf(cart) { return cart.items.reduce(function (s, it) { return s + (isAddon(it) ? 0 : it.final_line_price); }, 0); }
  function realCountOf(cart) { return cart.items.reduce(function (s, it) { return s + (isAddon(it) ? 0 : it.quantity); }, 0); }
  function formatMoney(cents) { return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' AUD'; }
  function parseCents(t) { if (!t) return null; var n = parseFloat(('' + t).replace(/[^0-9.]/g, '')); return isNaN(n) ? null : Math.round(n * 100); }
  function currentTotalCents() { var n = document.querySelectorAll('form.cart-recap .cart-recap__price-line-price'); if (n.length) return parseCents(n[n.length - 1].textContent); var m = document.querySelectorAll('#mini-cart .mini-cart__recap-price-line'); if (!m.length) return null; var sp = m[m.length - 1].querySelectorAll('span'); return sp.length ? parseCents(sp[sp.length - 1].textContent) : null; }

  /* stable row helpers: identify by the row's own links, never by positional index */
  function rowHref(tr, sel) { var a = tr.querySelector(sel); return a ? (a.getAttribute('href') || '') : ''; }
  function rowVariantId(tr, sel) { var m = rowHref(tr, sel).match(/variant=(\d+)/); return m ? parseInt(m[1], 10) : null; }
  function rowIsAddon(tr) { var links = tr.querySelectorAll('a[href]'); for (var i = 0; i < links.length; i++) { var h = links[i].getAttribute('href') || ''; if (h.indexOf(WARRANTY_HANDLE) !== -1 || h.indexOf(SHIP_HANDLE) !== -1) return true; } return false; }
  function itemForVariant(cart, vid) { if (!vid) return null; for (var i = 0; i < cart.items.length; i++) { var it = cart.items[i]; if (it.variant_id === vid && !isAddon(it)) return it; } return null; }

  var CSS = '' +
    '.vero-addon{display:block;margin:8px 0 2px;font-family:inherit;}' +
    '.vero-addon__row{display:flex;align-items:flex-start;gap:8px;cursor:pointer;font-size:.84rem;line-height:1.35;}' +
    '.vero-addon__row input{margin:2px 0 0;flex:0 0 auto;width:16px;height:16px;accent-color:#ff6e00;cursor:pointer;}' +
    '.vero-addon__label strong{font-weight:700;}' +
    '.vero-addon__plus{color:#ff6e00;font-weight:700;}' +
    '.vero-addon__sub{display:block;font-size:.76rem;opacity:.7;margin-top:1px;}' +
    '.vero-ship{border:1px solid rgba(255,110,0,.35);background:rgba(255,110,0,.06);border-radius:10px;padding:10px 12px;margin:12px 0;}' +
    '.vero-ship .vero-addon__row{font-size:.86rem;}' +
    '.line-item--vero-addon,.mini-cart__line-item--vero-addon{display:none !important;}';
  function injectStyle() { if (document.getElementById('vero-addon-style')) return; var s = document.createElement('style'); s.id = 'vero-addon-style'; s.appendChild(document.createTextNode(CSS)); (document.head || document.documentElement).appendChild(s); }

  function warrantyMarkup(d) {
    return '<span class="vero-addon__row"><input type="checkbox" class="vero-warranty-check">' +
      '<span class="vero-addon__label">Add <strong>2-Year Extended Warranty</strong> <span class="vero-addon__plus">(+$' + d + ')</span>' +
      '<span class="vero-addon__sub">Double your cover - 2 years total protection against faults &amp; defects.</span></span></span>';
  }
  function shipMarkup(d) {
    return '<label class="vero-addon__row"><input type="checkbox" class="vero-ship-check">' +
      '<span class="vero-addon__label">Add <strong>Shipping Protection</strong> <span class="vero-addon__plus">(+$' + d + ')</span>' +
      '<span class="vero-addon__sub">Guaranteed cover if your order is lost, stolen, or arrives damaged in transit.</span></span></label>';
  }
  function ensureWarranty(container, cart, it) {
    var d = warrantyDollars(it.final_line_price);
    var ex = container.querySelector('.vero-addon');
    if (!ex) { ex = document.createElement('label'); ex.className = 'vero-addon'; ex.innerHTML = warrantyMarkup(d); container.appendChild(ex); }
    var plus = ex.querySelector('.vero-addon__plus'); if (plus) plus.textContent = '(+$' + d + ')';
    var chk = ex.querySelector('.vero-warranty-check');
    if (chk) { chk.setAttribute('data-key', it.key); chk.setAttribute('data-amt', d); chk.checked = !!warrantyLineFor(cart, it.key); }
  }
  function ensureShip(container, insertAfter, cart) {
    var d = shipDollars(orderCentsOf(cart));
    var ex = container.querySelector('.vero-ship');
    if (!ex) { var w = document.createElement('div'); w.className = 'vero-ship'; w.innerHTML = shipMarkup(d); insertAfter.insertAdjacentElement('afterend', w); ex = w; }
    var plus = ex.querySelector('.vero-addon__plus'); if (plus) plus.textContent = '(+$' + d + ')';
    var chk = ex.querySelector('.vero-ship-check'); if (chk) { chk.setAttribute('data-amt', d); chk.checked = !!shipLineOf(cart); }
  }

  function setTotals(cents) {
    var cp = document.querySelectorAll('form.cart-recap .cart-recap__price-line-price');
    if (cp.length) cp[cp.length - 1].textContent = formatMoney(cents);
    var mc = document.querySelectorAll('#mini-cart .mini-cart__recap-price-line');
    if (mc.length) { var sp = mc[mc.length - 1].querySelectorAll('span'); if (sp.length) sp[sp.length - 1].textContent = formatMoney(cents); }
  }
  function setCount(cart) { var n = realCountOf(cart); try { localStorage.setItem('vero_rc', n); } catch (e) {} document.querySelectorAll('.header__cart-count').forEach(function (el) { el.textContent = n; }); }
  function applyCachedCount() { try { var v = localStorage.getItem('vero_rc'); if (v != null) document.querySelectorAll('.header__cart-count').forEach(function (el) { el.textContent = v; }); } catch (e) {} }

  function reconcile(cart) {
    var chain = Promise.resolve(); var changed = 0;
    cart.items.forEach(function (it) {
      if (it.variant_id === WARRANTY_ID) {
        var pk = it.properties && it.properties._covers;
        var parent = cart.items.filter(function (p) { return p.key === pk; })[0];
        if (!parent || !eligible(parent)) { changed++; chain = chain.then(function () { return changeLine(it.key, 0); }); }
        else { var want = warrantyDollars(parent.final_line_price) / UNIT; if (it.quantity !== want) { changed++; chain = chain.then(function () { return changeLine(it.key, want, it.properties); }); } }
      }
    });
    var sl = shipLineOf(cart);
    if (sl) { var oc = orderCentsOf(cart); if (oc <= 0) { changed++; chain = chain.then(function () { return changeLine(sl.key, 0); }); } else { var w = shipDollars(oc) / UNIT; if (sl.quantity !== w) { changed++; chain = chain.then(function () { return changeLine(sl.key, w, sl.properties); }); } } }
    return chain.then(function () { return changed; });
  }

  function renderCartPage(cart) {
    if (location.pathname.indexOf('/cart') !== 0) return;
    injectStyle();
    document.querySelectorAll('tr.line-item').forEach(function (tr) {
      if (rowIsAddon(tr)) { tr.classList.add('line-item--vero-addon'); return; }
      var it = itemForVariant(cart, rowVariantId(tr, 'a.line-item__title, .line-item__title'));
      if (!it || !eligible(it)) return;
      var meta = tr.querySelector('.line-item__meta'); if (!meta) return;
      ensureWarranty(meta, cart, it);
    });
    var recap = document.querySelector('form.cart-recap .card__section');
    var lines = document.querySelectorAll('form.cart-recap .cart-recap__price-line');
    if (recap && lines.length) ensureShip(recap, lines[lines.length - 1], cart);
  }

  function renderMini(cart) {
    injectStyle();
    var mc = document.getElementById('mini-cart'); if (!mc) return;
    mc.querySelectorAll('.mini-cart__line-item').forEach(function (row) {
      if (rowIsAddon(row)) { row.classList.add('mini-cart__line-item--vero-addon'); return; }
      var it = itemForVariant(cart, rowVariantId(row, 'a.mini-cart__product-title, .mini-cart__product-title'));
      if (!it || !eligible(it)) return;
      var info = row.querySelector('.mini-cart__product-info'); if (!info) return;
      ensureWarranty(info, cart, it);
    });
    var recap = mc.querySelector('.mini-cart__recap');
    var lines = mc.querySelectorAll('.mini-cart__recap-price-line');
    if (recap && lines.length) ensureShip(recap, lines[lines.length - 1], cart);
  }

  function renderAll(cart) { function go(c) { renderCartPage(c); renderMini(c); setCount(c); } if (cart) go(cart); else getCart().then(go); }

  /* toggles: serialized queue (none dropped), optimistic instant total, no reload, no section swap */
  var queue = Promise.resolve();
  document.addEventListener('change', function (e) {
    var el = e.target; if (!el || !el.classList) return;
    var isW = el.classList.contains('vero-warranty-check');
    var isS = el.classList.contains('vero-ship-check');
    if (!isW && !isS) return;
    var checked = el.checked;
    var key = isW ? el.getAttribute('data-key') : null;
    var amtCents = (parseInt(el.getAttribute('data-amt'), 10) || 0) * 100;
    var curc = currentTotalCents();
    if (amtCents && curc != null) setTotals(curc + (checked ? amtCents : -amtCents));
    queue = queue.then(function () {
      return getCart().then(function (cart) {
        if (isW) {
          var parent = cart.items.filter(function (p) { return p.key === key; })[0];
          var existing = warrantyLineFor(cart, key);
          if (checked && !existing && parent) { return addLine(WARRANTY_ID, warrantyDollars(parent.final_line_price) / UNIT, { _covers: key, 'Covers': parent.product_title }); }
          if (!checked && existing) { return changeLine(existing.key, 0); }
        } else {
          var sl = shipLineOf(cart);
          if (checked && !sl) { return addLine(SHIP_ID, shipDollars(orderCentsOf(cart)) / UNIT, { _addon: 'shipping' }); }
          if (!checked && sl) { return changeLine(sl.key, 0); }
        }
      }).then(function () { return getCart(); }).then(function (cart) { setTotals(cart.total_price); setCount(cart); renderAll(cart); });
    }).catch(function () {});
  });

  applyCachedCount();
  function boot() {
    applyCachedCount();
    getCart().then(function (cart) {
      return reconcile(cart).then(function (changes) {
        if (changes > 0) { return getCart().then(function (c2) { setTotals(c2.total_price); renderAll(c2); }); }
        renderAll(cart);
      });
    }).catch(function () {});
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  ['cart:refresh', 'cart:updated', 'product:added'].forEach(function (evt) { document.documentElement.addEventListener(evt, function () { setTimeout(function () { renderAll(); }, 150); }); });
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('a[href*="/cart"], [data-action*="cart"], [aria-controls*="mini-cart"], .header__cart, .header__cart-toggle, .js-cart-trigger');
    if (!t) return;
    setTimeout(function () { renderAll(); }, 300);
    setTimeout(function () { renderAll(); }, 900);
  });
})();

/**
 * Hide the add-on products from every storefront listing - Claude.
 * They stay published (so the cart can add them) but must never appear as browsable products. Hides any
 * product card/link pointing at the add-on handles across listings (grids, JS New Arrivals, search).
 * NEVER runs on the cart / mini-cart (those links are the real add-on lines). No persistent observer.
 */
(function () {
  var SLUGS = ['/products/shipping-protection', '/products/extended-warranty-2-years'];
  function onAddonPage() { return SLUGS.some(function (s) { return location.pathname.indexOf(s) === 0; }); }
  function matches(h) { return !!h && SLUGS.some(function (s) { return h.indexOf(s) !== -1; }); }
  function hide() {
    if (onAddonPage() || location.pathname.indexOf('/cart') === 0) return; // never run on the cart
    var links = document.querySelectorAll('a[href*="/products/shipping-protection"], a[href*="/products/extended-warranty-2-years"]');
    links.forEach(function (a) {
      if (a.__vh || !matches(a.getAttribute('href'))) return;
      if (a.closest('form.cart-recap, #mini-cart, .cart-wrapper, .line-item, .mini-cart__line-item, [data-section-type="cart"]')) return;
      a.__vh = 1;
      var card = a.closest('.na-card, .product-item, .product-card, [class*="grid__item"], [class*="product-list__item"], li');
      if (card) card.style.display = 'none';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hide); else hide();
  [400, 1200, 2500, 4500].forEach(function (ms) { setTimeout(hide, ms); });
  var st; window.addEventListener('scroll', function () { if (st) return; st = setTimeout(function () { st = null; hide(); }, 250); }, { passive: true });
})();


/**
 * Add-on + badge hardening (Claude) - timing-proof. Two fixes, both self-contained here:
 *
 * 1) The mini-cart drawer is re-rendered by the theme on every cart change, which wipes any JS-added
 *    hide class, so for a moment the raw add-on line ("Shipping Protection $5.00 x 66") and the Redeemly
 *    app's own store-credit badge flash into view before JS can re-hide them. We inject a CSS rule into
 *    <head> (never wiped) that hides those rows the instant they render, using :has() to match a row by
 *    the add-on product link it contains. No JS timing, no flash, survives every re-render.
 *
 * 2) The "Earn $X store credit" pill did not recompute when a warranty/shipping add-on was toggled
 *    (the add-on code updates the Total but never re-ran the credit badge), so the pill showed a stale
 *    amount. We recompute all cart + mini-cart pills from the live cart total after any add-on change
 *    (and on cart events / load), using the same formula as the badge: max($5, 5% of total), rounded.
 */
(function () {
  var css =
    'tr.line-item:has(a[href*="/products/extended-warranty-2-years"]),' +
    'tr.line-item:has(a[href*="/products/shipping-protection"]),' +
    '.mini-cart__line-item:has(a[href*="/products/extended-warranty-2-years"]),' +
    '.mini-cart__line-item:has(a[href*="/products/shipping-protection"]),' +
    '.line-item:has(a[href*="/products/extended-warranty-2-years"]),' +
    '.line-item:has(a[href*="/products/shipping-protection"]){display:none !important;}' +
    '.mcb-cart-widget,[id^="mcb__rewards-on-cart-widget"],#mini-cart .mcb-pdp-widget{display:none !important;}';
  function inj() {
    if (document.getElementById('vero-addon-has-fix')) return;
    var s = document.createElement('style');
    s.id = 'vero-addon-has-fix';
    s.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(s);
  }
  if (document.head) { inj(); }
  else if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', inj); }
  else { inj(); }

  /* --- Keep the store-credit pill in sync with the live total (incl. add-on toggles) --- */
  function creditDollars(totalCents) {
    if (totalCents == null) return null;
    var f = Math.round(totalCents * 0.05);
    return Math.round(Math.max(500, f) / 100);
  }
  function parseCents(t) {
    if (!t) return null;
    var n = parseFloat(('' + t).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : Math.round(n * 100);
  }
  // Read the Total the cart/mini already shows. The add-on code writes this authoritatively (optimistic,
  // then confirmed from the server), so tracking it never races the network.
  function displayedTotalCents() {
    var n = document.querySelectorAll('form.cart-recap .cart-recap__price-line-price');
    if (n.length) { var v = parseCents(n[n.length - 1].textContent); if (v != null) return v; }
    var m = document.querySelectorAll('#mini-cart .mini-cart__recap-price-line');
    if (m.length) { var sp = m[m.length - 1].querySelectorAll('span'); if (sp.length) return parseCents(sp[sp.length - 1].textContent); }
    return null;
  }
  function setPills(d) {
    if (d == null) return;
    document.querySelectorAll('.vero-credit--cart .vero-credit__amt').forEach(function (a) {
      if (a.textContent !== '$' + d) a.textContent = '$' + d;
    });
    document.querySelectorAll('.vero-credit--cart .vero-credit__tip strong, .vero-credit--cart .vero-credit__tipamt').forEach(function (a) {
      var want = (a.classList.contains('vero-credit__tipamt')) ? String(d) : '$' + d;
      if (a.textContent !== want) a.textContent = want;
    });
  }
  function tickPill() { setPills(creditDollars(displayedTotalCents())); }
  function refreshFromCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setPills(creditDollars(c.total_price)); })
      .catch(function () {});
  }
  // On an add-on toggle, poll the displayed Total for a few seconds so the pill tracks it to the settled value.
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.classList) return;
    if (!el.classList.contains('vero-warranty-check') && !el.classList.contains('vero-ship-check')) return;
    for (var k = 1; k <= 12; k++) setTimeout(tickPill, k * 350);
  });
  ['cart:refresh', 'cart:updated', 'product:added'].forEach(function (evt) {
    document.documentElement.addEventListener(evt, function () { setTimeout(refreshFromCart, 300); });
  });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { setTimeout(refreshFromCart, 400); }); }
  else { setTimeout(refreshFromCart, 400); }
})();
